import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useContext } from "react";
export const StliteKernelContext = React.createContext(undefined);
const Provider = StliteKernelContext.Provider;
export function StliteKernelProvider(props) {
    const { children, kernel } = props;
    const value = useMemo(() => {
        return {
            kernel,
        };
    }, [kernel]);
    return _jsx(Provider, { value: value, children: children });
}
export function useStliteKernel() {
    const value = useContext(StliteKernelContext);
    if (value == null) {
        throw new Error("useStliteKernel() must be inside <StliteKernelProvider />");
    }
    return value.kernel;
}
/**
 * The kernel if this tree is mounted under `<StliteKernelProvider />`, else
 * null. A null kernel means the app is server-backed (e.g. the Cloudflare
 * Workers frontend): callers fall back to upstream Streamlit behavior and
 * leave URLs, downloads, and component iframes to the real HTTP server.
 */
export function useStliteKernelIfAvailable() {
    return useContext(StliteKernelContext)?.kernel ?? null;
}
//# sourceMappingURL=StliteKernelProvider.js.map